module.exports = __webpack_public_path__ + "img/shopping-tools-tiles.8331d77b.png";